export default __webpack_public_path__ + "static/media/pic33.c2e022a0.jpg";